export default "__VITE_ASSET__546f238e__"